import React from 'react';
import dayjs from 'dayjs';
import useResourceLoader from '../util/useResourceLoader';
import UWEEntityApi from '../api/UWEEntityApi';
import Notification from '../components/Notification';
import { EmptyState } from '../components/Icons/EmptyStates';
import Loader from '../components/Loader';
import { Trans, useLingui } from '@lingui/react/macro';

function UWEEntityHistory({ entity, wfAccessToken }) {
  const entityId = entity?.id;

  const [history, loadingHistory = true, error] = useResourceLoader(
    () =>
      entityId
        ? UWEEntityApi.getUWEEntityHistory({ id: entityId, wfAccessToken }).then(data => {
            return data.map(item => ({ ...item, date: dayjs.utc(item.timestamp).local() }));
          })
        : [],
    [entityId],
    []
  );

  return loadingHistory ? (
    <Loader fullscreen>
      <Trans>Loading History...</Trans>
    </Loader>
  ) : (
    <>
      {error ? <Notification color="danger">{JSON.stringify(error)}</Notification> : null}
      <div className="uweentity-history-list h-full">
        {history.length ? (
          <div className="hist-timeline">
            {history.map((entry, idx) => (
              <SidePanelHistoryEntry key={idx} entry={entry} isLast={idx === history.length - 1} />
            ))}
          </div>
        ) : (
          <EmptyState icon="sleep" message="No history yet." size={160} />
        )}
      </div>
    </>
  );
}

function SidePanelHistoryEntry({
  entry: {
    date,
    user: { name },
    status,
    option,
    reason,
  },
  isLast,
}) {
  const { i18n } = useLingui();
  return (
    <div className="hist-entry">
      <div className="hist-indicator">
        <div className="hist-dot" />
        {!isLast && <div className="hist-line" />}
      </div>
      <div className="hist-body">
        <div className="hist-meta">
          <span className="hist-date">
            {date ? (
              <>
                {dayjs(date)
                  .locale(i18n.locale)
                  .format('LL, hh:mmA')}
              </>
            ) : (
              ' '
            )}
          </span>
          <span className="hist-user">{name}</span>
        </div>
        <div className="hist-action">{status}</div>
        {option ? <div className="hist-option">{option}</div> : null}
        {reason && reason.trim() ? <div className="hist-reason">{reason}</div> : null}
      </div>
    </div>
  );
}

export default UWEEntityHistory;
